import { FunctionComponent, ReactNode } from "react";
import styles from "./PublisherLetter.module.scss";
import strings from "./strings";
import { Props } from "./types";

function profilePicture(imageUrl: string): ReactNode {
  return (
    <img alt="profile image" className={styles.profileImage} src={imageUrl} />
  );
}

const PublisherLetter: FunctionComponent<Props> = ({ letter, siteName }) => {
  if (letter) {
    return (
      <div className={styles.letterSection}>
        {strings.title}
        <div className={styles.letterContainer}>
          <div className={styles.title}>{letter.title}</div>
          {letter.content && (
            <div
              className={styles.letter}
              dangerouslySetInnerHTML={{ __html: letter.content }}
            />
          )}
          <div className={styles.signature}>
            {letter.authorImageUrl && profilePicture(letter.authorImageUrl)}
            <div>
              {letter.authorName}
              <div className={styles.authorDetails}>{letter.authorTitle}</div>
              <div className={styles.authorDetails}>{siteName}</div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default PublisherLetter;
